import styled from "styled-components";
export const Wrapper = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 60px 20px;

  @media (max-width: 600px) {
    padding: 0px;
  }
`;
